/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  searchResult: [],
  checkNumber: '',
  errorList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_TOTAL_DOLLER_PAID_REPORT:
      return { ...state, searchResult: action.payload };
    case ActionTypes.REFRESH_TOTAL_DOLLER_PAID:
      return initialState;
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.CHECK_NUMBER_TDP:
      return { ...state, checkNumber: action.payload };
    case ActionTypes.ERROR_LIST_TDP:
      return { ...state, errorList: action.payload };
    default:
      return state;
  }
};

export default reducer;
